import React from 'react';
import { motion } from 'motion/react';

// Shared easing & timing so every entrance feels like it came from the same hand.
// Sade tutuyoruz: tek bir kısa fade — cascade/stagger yok, overshoot yok.
const EASE_OUT = [0.16, 1, 0.3, 1];

// Ortak, sakin giriş: küçük mesafe (12px) + kısa süre (0.5s).
export const fadeInUp = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: EASE_OUT } },
};

export const fadeInScale = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: EASE_OUT } },
};

// Stagger cascade kapalı: çocuklar tek tek değil hep beraber görünür.
export const staggerParent = () => ({
  hidden: {},
  visible: { transition: {} },
});

export const FadeIn = ({ children, delay = 0, y = 12, className, as = 'div', ...rest }) => {
  const Tag = motion[as] ?? motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '0px 0px -80px 0px' }}
      transition={{ duration: 0.5, ease: EASE_OUT, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

// stagger/delayChildren prop'ları hâlâ kabul edilir ama YOK SAYILIR (cascade kapalı);
// böylece 87 call site'ı değiştirmeye gerek kalmaz ve prop DOM'a sızmaz.
// eslint-disable-next-line no-unused-vars
export const Stagger = ({ children, className, stagger, delayChildren, ...rest }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: '0px 0px -80px 0px' }}
    variants={staggerParent()}
    {...rest}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className, as = 'div', ...rest }) => {
  const Tag = motion[as] ?? motion.div;
  return (
    <Tag className={className} variants={fadeInUp} {...rest}>
      {children}
    </Tag>
  );
};
